export enum WorkOrderStatus {
  COMPLETED = 'COMPLETED',
  IDLE = 'IDLE',
  INPROGRESS = 'INPROGRESS',
  READY = 'READY',
  CANCEL = 'CANCEL',
  ABANDONED = 'ABANDONED',
  DEFERRED = 'DEFERRED'
}
